import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { offerConverter } from '@pc-converter';
import { convertDateToTsSeconds, getFetchEndDateForModels } from '@pc-helpers';
import { EnvironmentService, StoreService } from '@pc-services';
import {
  PcOffer,
  PcOfferFirebase,
  PcTsSeconds,
  PC_COLLECTIONS,
} from '@pc-types';
import { ModelExtension } from './model.extension';

@Injectable({
  providedIn: 'root',
})
export class OfferService extends ModelExtension<PcOffer, PcOfferFirebase> {
  protected referenceMainCollection = PC_COLLECTIONS.OFFERS;
  protected referenceShopCollection = PC_COLLECTIONS.SHOP_OFFERS;

  constructor(
    protected angularFirestore: AngularFirestore,
    protected store: StoreService,
    protected envService: EnvironmentService
  ) {
    super({
      angularFirestore,
      store,
      modelConverter: offerConverter,
      envService,
    });
  }

  public fetchAll(): void {
    this.fetchItems().subscribe((news) => {
      this.store.setOffers(news);
    });
  }

  public fetchForFeed(): void {
    this.fetchItemsForFeed().subscribe((items) => {
      this.store.setFeedOffers(items);
    });
  }

  public getEndDateForFetch(): PcTsSeconds {
    return convertDateToTsSeconds(getFetchEndDateForModels());
  }

  public getEndDateForFetchFeed(): PcTsSeconds {
    return convertDateToTsSeconds(new Date());
  }
}
